import React, { useEffect, useState } from 'react';
import { Grid, CircularProgress, Typography, Divider, Box } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import Group from './Group';
import { getGroups } from '../../actions/groups';
import { styled } from '@mui/material/styles';
import { useAuth } from '../../contexts/AuthContext';
import LoginModal from '../Auth/LoginModal';

const StyledContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  padding: '24px 32px',
  width: '100%',
  minHeight: 'calc(100vh - 64px)',
});

const PageTitle = styled(Typography)({
  marginBottom: '24px',
  fontWeight: 600,
  fontFamily: '"Literata", Georgia, serif',
  color: '#4A3428',
  display: 'inline-block'
});

const StyledDivider = styled(Divider)({
  marginBottom: '24px',
  backgroundColor: '#e0e0e0'
});

const Groups = () => {        
  const dispatch = useDispatch();
  const groups = useSelector((state) => state.groups);
  const { isAuthenticated } = useAuth();
  const [showLoginModal, setShowLoginModal] = useState(false);

  useEffect(() => {
    dispatch(getGroups());
  }, [dispatch]);

  // Scroll effect: always show login modal for unauthenticated users
  useEffect(() => {
    if (!isAuthenticated) {
      const handleScroll = () => {
        if (window.scrollY > 100) {
          setShowLoginModal(true);
        }
      };
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, [isAuthenticated]);

  const handleGroupInteraction = () => {
    if (!isAuthenticated) {
      setShowLoginModal(true);
      return false;
    }
    return true;
  };

  const handleLoginModalClose = () => {
    setShowLoginModal(false);
  };

  const handleLoginSuccess = (user) => {
    setShowLoginModal(false);
    // Optionally refresh the page or redirect
    window.location.reload();
  };

  return (
    <StyledContainer>
      <PageTitle variant="h5">
        Discover stories from rejection groups and remember to be kind to yourself. 
        This is just a phase, and it will pass. These groups are here to support you 
        - explore and see that many share the same journey.
      </PageTitle>
      <StyledDivider />                                                                                          

      {!groups.length ? <CircularProgress /> : (
        <Grid 
          container 
          alignItems="flex-start" 
          spacing={4}
        >
          {groups.map((group) => (
            <Grid 
              key={group._id} 
              item 
              xs={12} 
              sm={6}
              md={4}
              lg={3}
            >
              <div 
                style={{ 
                  backgroundColor: '#f5f5f5',
                  border: `6px solid ${group.color || '#3498db'}`,
                  borderRadius: '12px',
                  padding: '20px',
                  minHeight: '140px',
                  width: '100%',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                  display: 'flex',
                  flexDirection: 'column',
                  position: 'relative',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}
                onClick={() => {
                  if (!handleGroupInteraction()) return;
                }}
              >
                <Group group={group} onInteraction={handleGroupInteraction} />
              </div>
            </Grid>
          ))}
        </Grid>
      )}
      
      <LoginModal 
        open={showLoginModal} 
        onClose={handleLoginModalClose} 
        onLoginSuccess={handleLoginSuccess} 
      />
    </StyledContainer>
  );
};

export default Groups;